module.exports = __webpack_public_path__ + "static/socialproof-cart-goal-bar-617c82124a18304913676edaf0c2a3b9.png";